import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../components/Navigation';
import { useViewConfig } from '../../hooks/useViewConfig';
import { BASE_LAYOUT_LIST } from '../../constants/viewConfig';
import { useIsSSCOMBrand } from '../../hooks/useIsSSCOMBrand';

import styles from './TwoColumnLayout.module.css';

const TwoColumnLayout = ({ header, children, className }) => {
  const BaseLayout = useViewConfig(BASE_LAYOUT_LIST);
  const isSCCOM = useIsSSCOMBrand();
  return (
    <BaseLayout
      header={header}
      sidebar={<Navigation className={isSCCOM && styles.nav_sccom} />}
      className={className}
    >
      {children}
    </BaseLayout>
  );
};

TwoColumnLayout.propTypes = {
  header: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
};

export default TwoColumnLayout;
